import { React, DomeComponent, DomeManipulator } from "@lexriver/dome"
import { Input } from "./form/Input"
import { Button } from "./form/Button"
import { IBasket } from "../Basket/IBasket"
import { GlobalBasket } from "../GlobalBasket"

import { UrlGenerator } from "../UrlGenerator"
import { GlobalUser } from "../GlobalUser"
import { EnumUserType } from "../enums/EnumUserType"
import { Settings } from "../../Settings"
import css from './BasketExportAsList.m.scss'
import { LoadingSpinnerForButton } from "./LoadingSpinnerForButton"
import { Link } from "./Link"
import { LinkToCopy } from "./LinkToCopy"
import { RequestMaker } from "../server-queries/RequestMaker"
import { ServerProductLists } from "../server-queries/ServerProductLists"


const filename = 'BasketExportAsList'
interface Attrs {

}
export class BasketExportAsList extends DomeComponent<Attrs> {
    refInputProductListName?: Input

    listName:string = ''

    link: string = ''

    render() {
        return (
            <div class={css.container}><LoadingSpinnerForButton /></div>
        )
    }

    async afterRender() {
        this.scheduleUpdate()

        GlobalBasket.onBasketUpdateEvent.subscribe(() => {
            // on change 
            this.link = ''
            this.scheduleUpdate()
        })
    }

    async updateAsync(): Promise<void> {
        const userType = await GlobalUser.getUserTypeAsync()
        if ([EnumUserType.Administrator, EnumUserType.SMM].includes(userType) == false) {
            await DomeManipulator.replaceAllChildrenAsync(this.rootElement, <></>)
            return
        }

        await DomeManipulator.replaceAllChildrenAsync(this.rootElement, <>
            {!this.link && 
                <div>
                    <div style={{paddingLeft: '10px'}}>
                        Название списка товаров
                    </div>
                    <div style={{paddingLeft: '5px'}}>
                        <Input inputType="text" ref={ref => this.refInputProductListName = ref} value={this.listName} />
                    </div>
                    <div style={{padding:'5px 0'}}>
                        <Button text="Создать список товаров и получить ссылку" onClick={async () => { await this.onExportToProductListAsync() }} />
                    </div>
                </div>
            }


            {this.link &&
                <>
                    <div>
                        <div>Список был успешно создан!</div>
                        {userType === EnumUserType.Administrator
                            ? <div>Теперь он доступен в администраторе в разделе <Link url={UrlGenerator.adminProductLists}>списки товаров</Link> и также по ссылке:</div>
                            : <div>Теперь он доступен по ссылке: '</div>
                        }
                    </div>
                    <LinkToCopy url={this.link} /*label="Ссылка на список"*/ />
                </>
            }

        </>)
        if (!this.link) {
            await this.assignNewProductListNameAsync()
        }
    }

    async assignNewProductListNameAsync() {

        const basket: IBasket = await GlobalBasket.getCurrentBasketAsync()
        if (basket.isEmpty()) {
            return
        }
        try {
            if (!this.refInputProductListName) throw new Error('no refInputProductListName')
            const basketStats = await basket.getStatsAsync({ getJsonOrderItems: false })
            //console.log('00] basketStats=', basketStats)
            const listName =
                'Список товаров от ' +
                Settings.formatDateSpecial(new Date()) +
                //Settings.formatDate(new Date().toISOString())+
                //new Date().toISOString() +
                (basketStats.skuQuantity ? (' - ' + Settings.formatCountOfProducts(basketStats.skuQuantity ?? 0)) : '')

            //console.log('00] listName=', listName)
            this.refInputProductListName?.setValue(listName)
            this.listName = listName
            //console.log('00] listName get = ', this.refInputProductListName?.getValue())

        } catch (x) {
            console.error('assignProductListNameAsync failed', x)
        }
    }


    async onExportToProductListAsync() {
        try {
            const basket: IBasket = await GlobalBasket.getCurrentBasketAsync()
            const list = await basket.getListOfRowsAsync()
            const productIds = list.map(x => x.product.id)
            const name = this.refInputProductListName?.getValue()
            //console.log('productIds=', productIds, 'name=', name)
            const listId = await RequestMaker.sendWebsocketJsonRequestAsync({ query: 'admin-productlist-new', params: { name, productIds } }, filename)
            if (!listId) {
                alert('Ошибка при создании списка!')
                return
            }
            const {list: productList} = await ServerProductLists.getOneAsync({
                listId: listId as string,
                productType: Settings.productTypeAll,
                pageNumber: 1,
                count: 1,
                getProductsAlso: false,
            })
            this.link = window.location.origin + UrlGenerator.productsByListWithDefaultParameters({ list: productList })
            this.scheduleUpdate()
            return true

        } catch (x) {
            console.error(filename, x)

        }

    }

}


